<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="会员之家列表" name="1">
      <HyzjAdd :updataID='updataID'></HyzjAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿产品修改
 */
import HyzjAdd from '../../../../static/form/HyzjAdd.vue'
export default {
  components: {
    HyzjAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Gywmgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/HyzjUpdate.vue